import Vue from 'vue';
import dialogPlugin from '@tencent/vft-vue-plugins/src/dialog';
import ImgPlugin from "../util/vImg";
import LoginPlugin from '@tencent/vft-component/LoginPanel';
import ScreenOrientation from '@tencent/vft-ui/src/ScreenOrientation';
import Avatar from '@tencent/vft-ui/src/Avatar';
Vue.use(ScreenOrientation);
Vue.use(LoginPlugin);
Vue.use(dialogPlugin);
Vue.use(ImgPlugin);
Vue.use(Avatar);